import { ReactNode } from 'react';

type BadgeProps = {
  className?: string;
  label: string;
  icon: ReactNode | null;
};

export function Badge({ className, label, icon }: BadgeProps) {
  return (
    <div
      className={`flex items-center gap-1 rounded-full px-2 py-0.5 bg-brand-amber-200 text-brand-amber-800 ${className || ''}`}
    >
      {icon ? icon : null}
      <span className="whitespace-nowrap text-xs font-sans font-medium leading-relaxed tracking-[0.015em] text-brand-amber">
        {label}
      </span>
    </div>
  );
}

export default Badge;
